import angular from 'angular';

angular.module('commonServices').factory('appMessages', ['$translate', appMessages]);

function appMessages($translate) {
  return function(msgString, params) {
    switch (msgString) {
      case 'SuccessTitle':
        return $translate.instant('Success');
      case 'ErrorTitle':
        return $translate.instant('Error');
      case 'WarningTitle':
        return $translate.instant('Warning');
      case 'ChangesSaved':
        return $translate.instant('ChangesSaved'); // 'Changes saved...'
      case 'msgConfirmChange':
        return $translate.instant('msgConfirmChange'); // 'Changes saved...'
      case 'msgItemRemoved':
        return $translate.instant('msgItemRemoved'); // 'Item removed...'
      case 'msgConfirmDeleteTitle':
        return $translate.instant('Delete?'); // 'Changes saved...'

      case 'msgGeneralError':
        return $translate.instant('msgGeneralError'); // 'Oops, something went wrong there...'
      //case 'msgSaveError':
      //    return $translate.instant('msgSaveError'); // Oei! Opslaan mislukt!
      //case 'msgRemoveError':
      //    return $translate.instant('msgRemoveError'); // Oei! Verwijderen mislukt!

      case 'msgPasswordChanged':
        return $translate.instant('Your password has been changed');
      case 'msgAddressSaved':
        return $translate.instant('msgAddressSaved'); // Adres opgeslagen
      case 'msgNewItemSaved':
        return $translate.instant('msgNewItemSaved');
      case 'msgCommSaved':
        return $translate.instant('msgCommSaved'); // commSetting opgeslagen
      case 'msgCommRemoved':
        return $translate.instant('msgCommRemoved'); // commSetting verwijderd
      case 'msgLinkRemoved':
        return $translate.instant('msgLinkRemoved'); // Link removed
      case 'msgEmpRemoved':
        return $translate.instant('msgEmpRemoved'); // Employee removed
      case 'msgAddressRemoved':
        return $translate.instant('msgAddressRemoved'); // Adres verwijderd
      case 'msgLinkSaved':
        return $translate.instant('msgLinkSaved'); // Link saved
      case 'msgNoAddressSelectedError':
        return $translate.instant('msgNoAddressSelectedError');
      case 'msgRemoved_name':
        return $translate.instant('msgRemoved_name', params); //
      case 'msgInactive_name':
        return $translate.instant('msgInactive_name', params); // {{name}} set to inactive
      case 'msgNewRelCreated':
        return $translate.instant('msgNewRelCreated');
      case 'msgNewEmpCreated':
        return $translate.instant('A new user was created and a confirmation mail sent.');
      case 'msgNewEmpError':
        return $translate.instant('msgNewEmpError');
      case 'msgSelectValueForAllFieldsError':
        return $translate.instant('msgSelectValueForAllFields');
      case 'Registration created':
        return $translate.instant('Registration created');
      case 'Edit registration':
        return $translate.instant('Edit registration');
      case 'msgRegRelationInactive':
        return $translate.instant(
          'You can not make a registration for this relation because it is inactive.',
        );
      case 'Because of linked invoices/registrations.':
        return $translate.instant('Because of linked invoices/registrations.');
      case 'Undo/Make active':
        return $translate.instant('Undo/Make active');
      case 'Registration modified':
        return $translate.instant('Registration modified');
      case 'Registration removed':
        return $translate.instant('Registration removed');
      case 'SynetonWelcome':
        return $translate.instant('SynetonWelcome');
      case 'SynetonWelcomeBack':
        return $translate.instant('SynetonWelcomeBack');
      case 'Register your time':
        return $translate.instant('Register your time');
      case 'Good morning!':
        return $translate.instant('Good morning!');
      case 'Good afternoon!':
        return $translate.instant('Good afternoon!');
      case 'Good evening!':
        return $translate.instant('Good evening!');
      case 'msgFileOpen':
        return $translate.instant('msgFileOpen'); // This file is open already
      case 'Line added':
        return $translate.instant('Line added');
      case 'Field config modified':
        return $translate.instant('Field config modified');
      case 'Field config removed':
        return $translate.instant('Field config removed');
      case 'Field config added':
        return $translate.instant('Field config added');
      case 'Field added':
        return $translate.instant('Field added');
      case 'Field updated':
        return $translate.instant('Field updated');
      case 'Forbidden':
        return $translate.instant('Forbidden');
      case 'msgMailsSent':
        return $translate.instant('{{p0}} mails sent', params);
      case 'msgSingleInvoiceEmailSent':
        return $translate.instant('Invoice for {{relation}} sent', params);
      case 'msgInvoiceMarkedAsSent':
        return $translate.instant('The invoice is marked as sent');
      case 'msgCreditNoteMarkedAsSent':
        return $translate.instant('The credit note is marked as sent');
      case 'msgXDraftInvoicesCreated':
        return $translate.instant('{{p0}} draft invoices created', params);
      case 'msgXDraftInvoicesChanged':
        return $translate.instant('{{p0}} draft invoices have been changed', params);
      case 'msgIncompleteEntryInMaskIsNoSave':
        return $translate.instant('msgIncompleteEntryInMaskIsNoSave');
      case 'msgPasswordReset':
        return $translate.instant(
          'Your password was reset and a mail was sent with a link to enter a new one. This link is only valid for 24h.',
        );
      case 'msgPasswordResetOtherUser':
        return $translate.instant(
          'The users password was reset and a mail was sent to enter a new one.',
        );
      case 'msgBrowserNotSupported':
        return $translate.instant(
          'Your current browser is not supported by AdminPulse. Although basic actions may still work in your current browser, you will will not be able to use all of the features. We suggest updating your browser.',
        );
      case 'comfirmTitle':
        return $translate.instant('Are you sure?');
      case 'comfirmDeleteTitle':
        return $translate.instant('Delete?');
      case 'comfirmDisableNotificationType':
        return $translate.instant('Turn of notifications of this type ?');
      case 'comfirmDeleteItem':
        return $translate.instant('Are you sure you want to delete this item?');
      case 'comfirmDeletePayment':
        return $translate.instant('Are you sure you want to delete this payment?');
      case 'comfirmDeleteInvoice':
        return $translate.instant('Are you sure you want to delete this invoice?');
      case 'comfirmUndoInvoice':
        return $translate.instant('Are you sure you want to undo this invoice?');
      case 'comfirmDeleteInvoiceLine':
        return $translate.instant('Are you sure you want to delete this invoice line?');
      case 'comfirmUndoInvoiceLine':
        return $translate.instant('Are you sure you want to undo this invoice line?');
      case 'comfirmUndoInvoiceDetailLine':
        return $translate.instant('Are you sure you want to undo this detail line?');
      case 'comfirmUndoOrNeverInvoiceDetailLine':
        return $translate.instant(
          'Are you sure you want to undo this detail line? Or never invoice it again?',
        );
      case 'comfirmUndoOrNeverInvoiceRegistrations':
        return $translate.instant(
          'Are you sure you want to undo all selected registrations? Or never invoice it again?',
          params,
        );
      case 'comfirmUndoOrNeverInvoiceLine':
        return $translate.instant(
          'Are you sure you want to delete this invoice line? All registrations will be moved to the next invoice or you can choose to never invoice them again?',
        );
      case 'comfirmDeleteInvoiceDetailLine':
        return $translate.instant('Are you sure you want to delete this detail line?');
      case 'comfirmDeleteTranslation':
        return $translate.instant('Are you sure you want to delete this translation?');
      case 'comfirmDeleteTemplate':
        return $translate.instant('Are you sure you want to delete this template?');
      case 'comfirmDeleteReminder':
        return $translate.instant('Are you sure you want to delete this reminder?');
      case 'comfirmDeleteResource':
        return $translate.instant(
          'Are you sure you want to delete this resource "{{name}}"?',
          params,
        );
      case 'comfirmDeletePrice':
        return $translate.instant('Are you sure you want to delete this price?');
      case 'comfirmDeletePriceStack':
        return $translate.instant('Are you sure you want to delete this stacked price?');
      case 'comfirmDeleteDiscount':
        return $translate.instant('Are you sure you want to delete this discount?');
      case 'comfirmDeleteDiscountStack':
        return $translate.instant('Are you sure you want to delete this stacked discount?');
      case 'comfirmResetPassword':
        return $translate.instant('Are you sure you want to reset your password?');
      case 'msgConfirmDeleteTaskTemplate':
        return $translate.instant('Are you sure you want to delete this task template?');
      case 'msgConfirmDeleteSubtaskTemplate':
        return $translate.instant('Are you sure you want to delete this subtask template?');
      case 'msgConfirmDeleteTaskSchedule':
        return $translate.instant('Are you sure you want to delete this task schedule?');
      case 'msgConfirmDeleteTaskScheduleLine':
        return $translate.instant('Are you sure you want to delete this task schedule line?');
      case 'msgConfirmDeleteDocument':
        return $translate.instant('Are you sure you want to delete this document?');

      case 'msgConfirmDeleteDocumentOrLink':
        return $translate.instant(
          'Do you want to delete the document (yes). Or delete the link but keep the document (no).',
        );
      case 'confirmDeleteInvoiceText':
        return $translate.instant('Are you sure you want to delete this invoice text?');
      case 'confirmNumberAndSendAllInvoices':
        return $translate.instant('Are you sure you want to number and send all invoices?');
      case 'confirmNumberAllInvoices':
        return $translate.instant('Are you sure you want to number all invoices?');
      case 'linkTransSuccess':
        return $translate.instant(
          'Link successfull, payment created for invoice {{invNr}}',
          params,
        );
      case 'linkTransMultiple':
        return $translate.instant('{{nr}} possible matching invoices found', params);
      case 'linkTransFailed':
        return $translate.instant('No matching invoices found');
      case 'mapsOriginNotFound':
        return $translate.instant('Origin address not found');
      case 'mapsDestinationNotFound':
        return $translate.instant('Destination address not found');
      case 'openFile':
        return $translate.instant('Open file');
      case 'msgPagingNoResults':
        return $translate.instant('Query returned no results');
      case 'msgPagingNoInvoiceResults':
        return $translate.instant('Query returned no invoices');
      case 'msgPagingNoRelationResults':
        return $translate.instant('Query returned no relations');
      case 'msgPagingNoTransactionResults':
        return $translate.instant('Query returned no transactions');
      case 'msgPagingNoResourceResults':
        return $translate.instant('Query returned no resources');

      case 'msgInvoiceProcessed':
        return $translate.instant('The invoice for {{name}} is being processed.', params);
      case 'msgExporterMissingAccNr20':
        return $translate.instant(
          'Export is not possible: there are missing accounting numbers in some relation files. Click to open the first 20.',
        );
      case 'msgExporterMissingAccNr':
        return $translate.instant(
          'Export is not possible: there are missing accounting numbers in some relation files. Click to open these files.',
        );
      case 'msgExporterMultipleCompanies':
        return $translate.instant(
          'You can only export invoices for 1 own company, use the own company filter in the advanced filters.',
        );
      case 'msgBatchMailMultipleCompanies':
        return $translate.instant(
          'You can only mail invoices for 1 own company, use the own company filter in the advanced filters.',
        );
      case 'msgInvoiceCountProcessed':
        return $translate.instant('{{count}} invoices are being processed.', params);
      case 'msgInvoiceCountDateToNumber':
        return $translate.instant('{{count}} invoices will be numbered on {{date}}', params);
      case 'msgInvoiceCountErrors':
        return $translate.instant('{{count}} invoices have errors.', params);
      case 'msgPositiveCreditNotesOrViceVersaCount':
        return $translate.instant(
          '{{count}} invoices are positive creditnotes and vice versa and we ask you to finalize these invoices individually.',
          params,
        );
      case 'trialAlmostExpired':
        return $translate.instant('Trial almost expired');
      case 'trialExpiresDays':
        return $translate.instant(
          'Your free trial period will end in {{nr}} days. Complete your registration to ensure your continued use of AdminPulse. Billing period will start AFTER the free trial period',
          params,
        );
      case 'trialExpiredMsg':
        return $translate.instant(
          'Your free trial period has expired.  Complete your registration to ensure your continued use of AdminPulse.',
        );
      case 'btnApply':
        return $translate.instant('Apply');
      case 'btnRegister':
        return $translate.instant('Register');
      case 'btnOpenRelation':
        return $translate.instant('Open relation');
      case 'btnOpenRelations':
        return $translate.instant('Open relations');
      case 'btnDraftInvoices':
        return $translate.instant('Open draft invoices');
      case 'msgNoDraftInvoiceCrm':
        return $translate.instant(
          'Invoicing not possible because the crm status of {{name}} is not customer',
          params,
        );
      case 'cancel':
        return $translate.instant('Cancel');
      case 'selectRelation':
        return $translate.instant('Select relation');
      case 'newCustomer':
        return $translate.instant('New customer');
      case 'newRelation':
        return $translate.instant('New relation');
      case 'newContact':
        return $translate.instant('New contact');
      case 'newBeneficiary':
        return $translate.instant('New beneficiary');
      case 'newOwnCompany':
        return $translate.instant('New own company');

      case 'msgFillOnCrmChange':
        var crmTypeKey = 'crmtype_' + params.newCrmType;
        params.newCrmType = $translate.instant(crmTypeKey);
        return $translate.instant('msgFillOnCrmChange', params);
      case 'msgRegistrationCreated':
        return params.relation + ' - ' + params.resource;
      case 'msgTaskTimeRegistrationCreated':
        return (
          $translate.instant('Registered {{duration}} for {{relation}}', params) +
          ' - ' +
          $translate.instant('Click here to edit')
        );
      case 'msgTaskTimeRegistrationStarted':
        return $translate.instant("Started time registration on '{{task}}'", params);
      case 'msgTaskTimeRegistrationStillRunning':
        return (
          $translate.instant(
            "Time registration on '{{task}}' for {{relation}} is still running.",
            params,
          ) +
          ' - ' +
          $translate.instant('Duration: {{duration}}', params)
        );
      case 'msgTaskTimeRegistrationDiscarded':
        return $translate.instant('Registration discarded (less than 1 minute)');
      case 'msgRegistrationCreatedTruncated':
        return (
          params.relation +
          ' - ' +
          params.resource +
          ' (' +
          $translate.instant('The end time was truncated') +
          ')'
        );
      case 'msgCODAProcessed':
        return $translate.instant(
          'The CODA file has been processed. {{n}} transactions have been created.',
          params,
        );
      case 'msgFieldsNeededCompleteFile':
        return $translate.instant(
          'The following fields are needed to complete this file: {{list}}',
          params,
        );

      case 'msgCompanyFillInEnterpriseNrCBE':
        return $translate.instant(
          'Fill out your enterprise number and the other data for your company will be fetched from the CBE.',
        );
      case 'btnEditEnterpriceNr':
        return $translate.instant('Edit');
      case 'msgCompanyCBENotFound':
        return $translate.instant('This enterprise number could not be found in the CBE database.');
      case 'msgInvalidPhoneNumber':
        return $translate.instant('Please enter a valid phone number');
      case 'msgCreateNewPrice':
        return $translate.instant('A new price will be created');

      case 'msgRegistrationPriceInactive':
        return $translate.instant(
          'The price labeled "{{desc}}" set on this registration is no longer active. While you may retain this price, you could also choose between the active prices below.',
          params,
        );
      case 'msgOnePriceAlreadySet':
        return $translate.instant(
          'This resource only has one price available. This price is already used.',
        );
      case 'msgNoPricesAvailable':
        return $translate.instant('This resource has no available prices.');
      case 'msgNegativePriceNotAllowed':
        return $translate.instant('Negative prices are not allowed.');
      case 'msgDateCannotBeSetBefore':
        return $translate.instant('This date cannot be set to a value before {{date}}.', params);
      case 'msgDownloadingFile':
        return $translate.instant(
          'Your download is being prepared. This could take a few moments.',
        );

      case 'msgVirusScanSuccessfull':
        return $translate.instant('No virus found in "{{name}}"', params);
      case 'msgVirusScanPending':
        return $translate.instant(
          'Our scanning service is unavailable at the moment, we will retry in a minute.',
        );
      case 'msgVirusScanVirusFound':
        return $translate.instant(
          'We found a virus in the file "{{name}}", please upload another file without a virus.',
          params,
        );

      case 'popupBlockedMsg':
        return $translate.instant(
          'Your browser prevented the tab from opening, most likely because of a pop-up blocker.',
        );
      case 'popupBlockedActionMsg':
        return $translate.instant(
          'Your browser prevented the tab from opening, most likely because of a pop-up blocker. For more information about turning this feature off: ',
        );
      case 'popupBlockedActionBtn':
        return $translate.instant('Read article');

      case 'msgNegativeDiscountWarning':
        return $translate.instant('A discount is saved as a positive number.');
      case 'msgApplyDiscountsToInvoices':
        return $translate.instant('Apply the new discount to existing invoice proposals?');
      case 'msgCannotSendNoRelationEmail':
        return $translate.instant(
          'Invoice can only be sent if you add an emailaddress to the relation file.',
        );
      case 'msgUpdateDraftInvoicesTitle':
        return $translate.instant('Update draft invoices?');

      case 'msgTemplateNotInLanguage':
        return $translate.instant('There is no mail template for the language of this customer.');
      case 'msgRelationsImported':
        return $translate.instant('msgRelationsImported', params); //
      case 'msgTemporaryRelationDeleted':
        return $translate.instant('The relation to import was deleted.');
      case 'msgChangeInvoiceStreamScheduleTitle':
        return $translate.instant('Update invoice schedule');
      case 'msgInvoiceStreamChangeExistingSchedules':
        return $translate.instant('Do you want to update the existing lines accordingly?');
      case 'msgDeleteInvoiceStreamScheduleLine':
        return $translate.instant('Are you sure you want to delete this invoice schedule line?');
      case 'msgInvoiceStreamScheduleLineDeleted':
        return $translate.instant('Invoice schedule line deleted');
      case 'msgDeleteBudget':
        return $translate.instant('Are you sure you want to delete this budget line?');
      case 'msgDeletePlannedRegistrationLine':
        return $translate.instant(
          'Are you sure you want to delete this planned registration line?',
        );
      case 'msgPlannedRegistrationLineDeleted':
        return $translate.instant('Planned registration line deleted');
      case 'msgDeletePlannedRegistration':
        return $translate.instant('Are you sure you want to delete this planned registration?');
      case 'msgRegistrationRemoved':
        return $translate.instant('Planned registration deleted');

      case 'msgRelationFileQueued':
        return $translate.instant(
          'The file has been successfully queued. Processing will begin shortly.',
        );
      case 'msgRelationImportCompleted':
        return $translate.instant('Your relation file was processed successfully');
      case 'msgTaskPlannedOn':
        return $translate.instant(
          'The task {{name}} has been planned with deadline {{deadline}}',
          params,
        );
      case 'msgDefaultSettingsRestored':
        return $translate.instant('The default settings are restored');
      case 'msgRelationsWithSameAccountingNr':
        return $translate.instant('This accounting number is already in use for: {{p0}}', params);
      case 'msgRelationsSameCustomerCode':
        return $translate.instant('This code is already in use for: {{p0}}', params);
      case 'msgTaskStateChangeError':
        return $translate.instant(
          'Not allowed. There is at least one child task still in progress.',
        );
      case 'msgConfirmDeleteRegistration':
        return $translate.instant('Are you sure you want to delete this registration?');
      case 'msgConfirmDeleteEmployee':
        return $translate.instant('Are you sure you want to delete this employee?');
      case 'msgConfirmDeleteTimeTable':
        return $translate.instant(
          'Are you sure you want to delete the time table for this employee?',
        );
      case 'msgNoConditionTaskInProgress':
        return $translate.instant("You can't move a condition to 'In Progress'");
      case 'msgDeleteTaskSchedule':
        return $translate.instant('Delete task schedule');
      case 'msgDeleteTransaction':
        return $translate.instant('Are you sure you want to delete this transaction?');
      case 'msgDeleteTaskScheduleAlsoDeletePlannedTasks':
        return $translate.instant(
          'Do you want the remove the tasks linked to this schedule from the taskboard?',
        );
      case 'msgConfirmAddDuplicateTaskSchedule':
        return $translate.instant(
          'A schedule for this task already exists. Are you sure you want to continue? All tasks will be put on the taskboard twice',
        );
      case 'msgConfirmChangeInvoiceMethodTitle':
        return $translate.instant('Change invoice method');
      case 'msgConfirmChangeInvoiceMethod':
        return $translate.instant(
          'Changing the invoice method with immediate effect may cause advances and/or registrations never to be settled. If you continue, you must be certain that all advances and registrations have been billed at this point!',
        );
      case 'msgEmployeeRestoreSuccesful':
        return $translate.instant('Employee restored');
      case 'msgConfirmRestoreTitle':
        return $translate.instant('Restore employee');
      case 'confirmDeleteInvoiceAttachment':
        return $translate.instant(
          'Are you sure you want to delete this attachment from this invoice?',
        );
      case 'confirmDeleteEmailAttachment':
        return $translate.instant(
          'Are you sure you want to delete this attachment from this email?',
        );
      case 'confirmDeleteAttachment':
        return $translate.instant('Are you sure you want to delete this attachment?');
      case 'msgInvoiceScheduleExistingLinesBeforeStartDateNotDeleted':
        return $translate.instant(
          'New settings apply from the entered date. If existing schedule lines before this date should not be executed, you need to remove them manually.',
        );
      case 'msgMainTaskDeadlineMovedForward':
        return $translate.instant(
          'New deadline saved. The deadlines of the subtasks have been brought forward equally.',
        );
      case 'msgMainTaskAutomaticallySaved':
        return $translate.instant('Your task was automatically saved.');
      case 'msgMainTaskDeadlinePostponed':
        return $translate.instant(
          'New deadline saved. The deadlines of the subtasks have been postponed equally.',
        );
      case 'msgRelationUpdated':
        return $translate.instant('Relation updated successfully.');
      case 'taskMgmtSendMailTitle':
        return $translate.instant('By dragging this task directly to done, the mail was not send.');
      case 'taskMgmtSendMailContent':
        return $translate.instant('Click here to send it anyway');
      case 'msgTaskEmailCancelled':
        return $translate.instant(
          "Because the mail was not sent, this task is returned to state 'to do'",
        );
      case 'msgNoRegistrationMadeDefaultTimeZero':
        return $translate.instant('No time was registred because the default duration is 0');
      case 'msgPaymentProviderChangedSuccess':
        return $translate.instant('Payment details for {{provider}} saved sucessfully.', params);
      case 'msgPaymentProviderChangedError':
        return $translate.instant(
          'Something went wrong while changing payment provider. Please try again.',
        );
      case 'msgChangeTwikeyAccountNumberSuccess':
        return $translate.instant('Request to change Twikey account number submitted succesfully.');
      case 'msgChangeTwikeyAccountNumberError':
        return $translate.instant(
          'Something went wrong while submitting your request to change Twikey account number. Please try again.',
        );
      case 'msgTwikeyPaymentMethodReactivated':
        return $translate.instant('Your existing Twikey mandate has been reactivated.');
      case 'msgModuleConfigurationSaved':
        return $translate.instant('Module configuration saved');
      case 'msgTaskTemplateCopied':
        return $translate.instant('Task template copied');
      case 'msgRequiredField':
        return $translate.instant('Dit veld is verplicht.'); // Key is in dutch

      case 'msgChoosePaymentMethod':
        return $translate.instant('Please configure your payment method first.');
      case 'msgPayNowSuccess':
        return $translate.instant('You will receive the invoice shortly in your mail inbox.');
      case 'confirmDeleteAuthorizationLetter':
        return $translate.instant('Are you sure you want to delete this authorization letter?');

      case 'msgFillInCompanySettings':
        return $translate.instant('Click here to fill in your company settings');

      case 'msgNumberLicensesLowerThanEmployees':
        return $translate.instant(
          "The number of licenses can't be lower than the number of employees. Please remove (an) employee(s) with a user account first.",
        );
      case 'msgConfirmAddInvoiceTemplate':
        return $translate.instant('Invoice template added');
      case 'msgConfirmDeleteInvoiceTemplate':
        return $translate.instant('Are you sure you want to delete this template?');
      case 'msgConfirmDeleteRelationLink':
        return $translate.instant('Are you sure you want to delete this link?');
      case 'msgConfirmChangePaymentProvidertitle':
        return $translate.instant('Change payment provider');
      case 'msgConfirmChangePaymentProvider':
        return $translate.instant('Are you sure you want to change your payment provider?');
      case 'msgConfirmDeleteSystemTaskTemplate':
        return $translate.instant(
          'Are you sure you want to delete this system task template? It cannot be restored later.',
        );
      case 'msgJobStarted':
        return $translate.instant(
          'A background job has started. Click here to monitor the progress.',
        );
      case 'msgJobFinished':
        return $translate.instant('A background job has finished.');
      case 'msgJobFailed':
        return $translate.instant('A background job has failed');
      case 'msgPropogateTaskTemplateChangesCount':
        return $translate.instant(
          '{{count}} task(s) on the taskboard have been updated accordingly.',
          params,
        );
      case 'msgConfirmPropogateTemplateChangesTitle':
        return $translate.instant('Update task template');
      case 'msgInvoicesSentToConnect':
        return $translate.instant('Invoices sent to connect service.');
      case 'msgConfirmPropogateTemplateChanges':
        return $translate.instant(
          'Do you want to apply the changes to the tasks on the taskboard linked to this template?',
        );
      case 'msgConfirmPropagateSubtaskTemplateDelete':
        return $translate.instant(
          'Do you also want to delete the subtasks on the taskboard linked to this template?',
        );
      case 'msgConfirmPropagateTemplateDelete':
        return $translate.instant(
          'Do you also want to delete the tasks on the taskboard linked to this template?',
        );
      case 'msgAddedRegistrationToDraftInvoice':
        return $translate.instant('Registration added to draft invoice.');
      case 'msgRemovedRegistrationFromDraftInvoice':
        return $translate.instant('Registration removed from draft invoice.');
      case 'msgInvoiceRegistrationNoInvoiceCreated':
        return $translate.instant(
          'There was no draft invoice created for this registration because of the invoice schedule of this relation.',
        );
      case 'msgRegistrationMovedToOtherDraftInvoice':
        return $translate.instant('The registration was moved to another draft invoice');
      case 'msgClickToOpenDraftInvoice':
        return $translate.instant('Click to open the draft invoice');
      case 'msgConfirmDeleteEmployeeProfile':
        return $translate.instant(
          'Are you sure you want to delete this employee profile? All employees linked to this profile will be assigned to the default profile.',
        );
      case 'msgConfirmPropogateChangesTitle':
        return $translate.instant('Propogate changes');
      case 'msgConfirmPropogateResourceForfaitChanges':
        return $translate.instant(
          'Do you want to propogate this change to all open registrations?',
        );

      case 'msgChooseExistingTeamFromList':
        return $translate.instant(
          'Please enter an existing team. A new team can be created in the settings.',
        );
      case 'msgTeamListEmpty':
        return $translate.instant(
          "You've cleared the list of teams. This relation will now be visible to everyone.",
        );
      case 'msgConfirmDeleteUBOVerification':
        return $translate.instant('Are you sure you want to delete this UBO verification?');
      case 'msgDeleteTaskParameter':
        return $translate.instant(
          'Are you sure you want to delete this task parameter? It will no longer be available in email templates and tasks using this parameter.',
        );
      case 'msgStartEndDateRequiredUpdateInternalPrice':
        return $translate.instant('Please fill out start and end date.');
      case 'msgInvoiceScheduleDateChangedInvoiceCreationDate':
        return $translate.instant(
          'We changed the invoice creation date to be one day after the registration until date',
        );
      case 'msgInvoiceScheduleDateChangedDate':
        return $translate.instant(
          'We changed the registration until date to be one day before the invoice creation date',
        );
      case 'msgOpenInvoicesInTabsIsLimited':
        return $translate.instant(
          'The number of invoices you can open in separate tabs is limited to 10',
        );
      case 'msgCreateFileInBackgroundFailed':
        return $translate.instant(
          'Something went wrong while creating the file. Please try again later.',
        );
      case 'msgClickHereToDownloadDocument':
        return $translate.instant(
          'Your file is ready to download. Click here if this does not happen automatically.',
        );
      case 'msgDocumentReady':
        return $translate.instant('Document ready');
      case 'msgCouldNotFindInvoicePdf':
        return $translate.instant(
          'Invoice PDF could not be found. Please contact support if this problem persists.',
        );
      case 'msgChangesSavedForName':
        return $translate.instant('Changes saved for {name}', params);
      case 'msgInvalidEmailAddress':
        return $translate.instant('An invalid email address was entered.');
      case 'msgEmailChangeUsernameSent':
        return $translate.instant('An email to change your username was sent.');
      case 'msg2FAEnabled':
        return $translate.instant('2-FA has been enabled.');
      case 'msg2FADisabled':
        return $translate.instant('2-FA has been disabled.');
      case 'comfirmUnnumberInvoiceTitle':
        return $translate.instant('Unnumber invoice?');
      case 'comfirmUnnumberInvoiceMessage':
        return $translate.instant('Are you sure want to unnumber this invoice?');
      case 'msgInvoiceSuccessfullyUnnumbered':
        return $translate.instant('The invoice was successfully unnumbered');
      case 'comfirmUndoWriteOffInternallyTitle':
        return $translate.instant('Undo write off internally?');
      case 'comfirmUndoWriteOffInternallyMessage':
        return $translate.instant('Are you sure want to change this back to a draft invoice?');
      case 'EmailSent':
        return $translate.instant('Email sent');
      case 'MsgNoSigningProviderConfiguredSeeSettings':
        return $translate.instant(
          'No signing provider has been configured. You can configure a document signing provider under general settings.',
        );
      case 'msgRequiredDocumentSigner':
        return $translate.instant('Please select a signer for each required signature.');
      case 'msgDocumentSigningRequestSent':
        return $translate.instant('Request to sign document has been sent.');
      case 'msgDocumentSigningRequestFailed':
        return $translate.instant('Something went wrong while creating the signature request.');
      case 'msgDocumentSingingRequestRevoked':
        return $translate.instant('Document signature request was revoked.');
      case 'msgDocumentRevokeSigningRequestFailed':
        return $translate.instant('Something went wrong while revoking the signature request.');
      case 'msgConfirmRevokeSignature':
        return $translate.instant('Are you sure you want to revoke the signature request?');
      case 'msgRequiredEnterpriseNumberAndAddress':
        return $translate.instant('Enterprise number and company address are mandatory.');
      case 'msgInvoicesWillBeMarkedAsSent':
        return $translate.instant('The selected invoices will be marked as sent shortly.');
      case 'msgIncludeNonBillableRegistrationsTitle':
        return $translate.instant('Include non billable registrations?');
      case 'msgDiscardCheckout':
        return $translate.instant(
          'Are you sure you want to discard this checkout? it is currently checked out by {{name}}?',
          params,
        );
      case 'msgIncludeNonBillableRegistrationsMsg':
        return $translate.instant(
          'Do you want to include non-billable registrations in the invoice detail?',
        );
      case 'confirmRevertDraftInvoices':
        return $translate.instant('Are you sure you want to revert these draft invoices?');
      case 'msgConfirmUseSharedCustomerCodeSetup':
        return $translate.instant(
          'Are you sure you want to use the same automated customer code setup for all companies? The customer code settings will be set to the default value (None).',
        );
      case 'msgConfirmUseCustomCustomerCodePerCompany':
        return $translate.instant(
          'Are you sure you want to use a custom customer code setup for each company? Each company will then have its own automated customer code settings.',
        );
      case 'msgConfirmUseSharedAccountingNrSetup':
        return $translate.instant(
          'Are you sure you want to use the same automated accounting nr setup for all companies? The accounting nr settings will be set to the default value (None).',
        );
      case 'msgConfirmUseCustomAccountingNrPerCompany':
        return $translate.instant(
          'Are you sure you want to use a custom accounting nr setup for each company? Each company will then have its own automated accounting nr settings.',
        );
      case 'msgPropagateLedgerAccountChangesToExistingSchedule':
        return $translate.instant(
          'Do you want to propagate this new ledger account to existing invoice schedules?',
        );
      case 'msgTaskTemplateHasAllAvailableRelationFields':
        return $translate.instant('This task template already has all available relation fields');
      case 'msgSelectTableColumns':
        return $translate.instant('Select which columns you want to display in the table');
      case 'msgConfirmChangeScheduleDateMessage':
        return $translate.instant(
          'The date you picked differse more than a month from the original date, are you sure you want to change this date? You can always create a support ticket if you feel like something is wrong with your invoice schedules.',
        );
      case 'msgInvoicesWillBeMarkedAsPaid':
        return $translate.instant(
          'The selected invoices will be marked as paid in the background.',
        );
      case 'msgTaskUserChangedError':
        return $translate.instant('Something went wrong while changing the assigned user.');
      case 'msgInvoiceExportStatusWillBeCleared':
        return $translate.instant(
          'The export status of the selected invoices will be cleared in the background.',
        );

      case 'msgConfirmLeavePage':
        return $translate.instant('Leave page?');
      case 'msgConfirmLeavePageMessage':
        return $translate.instant(
          'You changed something, leaving the page will discard the made changes.',
        );
      case 'msgInvoicesWillBeMarkedAsExported':
        return $translate.instant('The invoices will be marked as exported in the background.');
      case 'msgSelectionContainedAlreadyExportedInvoices':
        return $translate.instant(
          'The selection contained already exported invoices. These were not included in the export.',
        );
      case 'UploadSuccessful':
        return $translate.instant('Upload successful');

      case 'SearchCriteriaNameInputTitle':
        return $translate.instant('SearchCriteriaNameInputTitle');
      case 'SearchCriteriaNameInputMessage':
        return $translate.instant('SearchCriteriaNameInputMessage');
      case 'SearchCriteriaNameInputPlaceholder':
        return $translate.instant('SearchCriteriaNameInputPlaceholder');
      case 'msgConfirmDeleteRelationTag':
        return $translate.instant('Are you sure you want to delete this tag?');
      case 'msgOneOfInvoicesAlreadySent':
        return $translate.instant(
          'One of the selected invoices has already been sent. Do you want to continue?',
        );
      case 'msgConfirmDeleteActiveInvoiceScheduleWithDraftInvoices':
        return $translate.instant(
          'There is still a draft invoice that was created by this schedule. If you delete this schedule, the draft invoice will be deleted and the registrations will be moved back to open registrations. Are you sure you want to do this?',
        );
      case 'msgConfirmDeleteActiveInvoiceSchedule':
        return $translate.instant('Are you sure you want to delete this invoice schedule?');
      case 'msgConfirmDeleteNotificationsOfType':
        return $translate.instant('Do you also want to delete all notifications of this type?');
      case 'msgCompanyCreatedInEstox':
        return $translate.instant('The company was created as concept in eStox');
      case 'msgRecalcDeadlinesTitle':
        return $translate.instant('Recalculate task deadlines?');

      case 'msgRecalcDeadlinesMessage':
        return $translate.instant(
          'There are {{count}} planned tasks with a deadline based on the general meeting or end fiscal year. Do you want to recalculate the deadline of these tasks?',
          params,
        );
      case 'msgBatchUpdateRegistrationsSuccess':
        return $translate.instant('{{count}} registrations where updated.', params);
      case 'msgComplianceRecalculationStarted':
        return $translate.instant(
          'Changes saved. The compliance will be recalculated in the background.',
        );
      case 'msgComplianceRecalculationCompleted':
        return $translate.instant('The compliance recalculation has completed.');
      case 'msgXTransactionsDeleted':
        return $translate.instant('{{p0}} transactions deleted', params);

      case 'confirmDeleteEmailDomain':
        return $translate.instant(
          'Are you sure you want to delete the email domain? All e-mails sent by AdminPulse will now use inbox@adminpulse.be as sender.',
        );

      case 'msgEmailDomainVerificationSucceeded':
        return $translate.instant(
          'CNAME verification succeeded. Mails sent from {{domain}} will be authenticated by the domain.',
          params,
        );

      case 'msgEmailDomainVerificationFailed':
        return $translate.instant(
          'CNAME verification failed. Make sure all 3 CNAME records are present in the DNS settings for domain {{domain}}. It can take up to 48 hours before the CNAME records are available to be verified. If the problem still persists, please visit the article or contact our helpdesk.',
          params,
        );
      case 'msgEmailDomainAddedVerificationPending':
        return $translate.instant(
          'The domain was added successfully. Please add the CNAME records to the DNS settings of {{domain}}',
          params,
        );
      case 'msgCompanyEmailRequiredBeforeVerification':
        return $translate.instant(
          'Please fill in a company e-mailaddress via the menu option "Own company" before verifying the domain.',
        );
      case 'msgEmailDomainVerificationRequired':
        return $translate.instant(
          'E-mails will now be sent using {{companyEmail}}, however the email domain still needs to be verified in order to prevent emails to be delivered in the spam folder.',
          params,
        );
      case 'msgInvoiceWillBeProcessedTonight':
        return $translate.instant(
          'The invoice will be processed tonight, using invoice date {{date}}',
          params,
        );
      case 'msgConfirmBillRegistrations':
        return $translate.instant(
          'Are you sure you want to add these registrations to draft invoices?',
        );
      case 'selectionContainsDocumentPendingOrAlreadySigned':
        return $translate.instant(
          'One or more documents selected is already awaiting signature or is already signed.',
        );
      case 'msgConfirmDeleteDocuments':
        return $translate.instant('Are you sure you want to delete these documents?');
      case 'msgTaskPlanningXSchedulesQueued':
        return $translate.instant(
          'The taskplanning was queued for {{count}} task schedules. The planning will run in the background and can take a few minutes to finish.',
          params,
        );
      case 'msgTaskPlanningNothingQueued':
        return $translate.instant(
          'There are no task schedules to be queued for this task template',
        );

      case 'comfirmUndoOrNeverSettledAdvanceLine':
        return $translate.instant(
          'Are you sure you want to delete this advance? Settle advance on next settlement or delete it forever and never settle it?',
        );
      case 'neverSettleAdvance':
        return $translate.instant('Delete advance and never settle it');
      case 'neverSettleAdvancesAndNeverInvoiceRegistrations':
        return $translate.instant('Never invoice advance(s) and registration(s) again');
      case 'msgUnnumberInvoiceTwikeyWarning':
        return $translate.instant(
          'This invoice might already exist in Twikey. Please delete the invoice in Twikey before numbering this invoice again, otherwise the payment info will be incorrect.',
        );
      case 'msgEditInvoiceTwikeyWarning':
        return $translate.instant(
          'This invoice might already exist in Twikey. Please delete the invoice in Twikey before editing and saving this invoice, otherwise the payment info will be incorrect.',
        );
      case 'msgTransactionMovedToOpenTransactions':
        return $translate.instant('Transaction moved to open transactions');
      case 'msgArchiveTransactionExplanation':
        return $translate.instant(
          'Are you sure you want to delete this transaction? Since there are one or more payments linked to the transaction, it will be archived and moved to the closed transactions instead.',
        );
      case 'msgRequiredEmailSubjectAndBody':
        return $translate.instant('E-mail subject and body are required.');

      case 'msgRelationFoundOnPeppolNetwork':
        return $translate.instant(
          'The relation was found on the PEPPOL network. You can now send invoices to the PEPPOL network for this relation.',
        );
      case 'msgInvoiceSentViaPeppol':
        return $translate.instant('The invoice was sent to the PEPPOL network.');
      case 'msgRelationNotFoundOnPeppolNetwork':
        return $translate.instant('The relation was not found on the PEPPOL network');
      case 'msgRelationFoundOnPeppolNetworkButNoSupportedDocumentFormats':
        return $translate.instant(
          'The relation was found on the PEPPOL network, but does not support any invoice formats that are also supported by AdminPulse',
        );
      case 'msgSwitchInvoiceStrategyToPeppolAfterInvoiceSent':
        return $translate.instant(
          'The invoice was sent through the PEPPOL network. Do you want to switch the invoice strategy for this relation to PEPPOL?',
        );
      case 'msgSwitchInvoiceStrategyToPeppolAfterLookup':
        return $translate.instant(
          'The relation was found on the PEPPOL network. Do you want to switch the invoice strategy for this relation to PEPPOL?',
        );

      case 'msgInvoiceAlreadyExportedViaPeppol':
        return $translate.instant(
          'This invoice was already sent to the PEPPOL network. Are you sure you want to send it again?',
        );
      case 'msgInvoiceNotRemovedFromTwikey':
        return $translate.instant(
          'The invoice was unnumbered but could not be removed in Twikey. Please remove the invoice in Twikey before numbering this invoice again.',
        );
      case 'msgDirectDebitInviteSent':
        return $translate.instant('Direct debit invite was sent to the customer.');
      case 'msgConfirmDeleteRelation':
        return $translate.instant('Are you sure you want to delete this relation?');
      case 'msgRelationSetToInactive':
        return $translate.instant(
          'Relation put inactive because registrations and/or invoices exist for this relation, or because this relation is linked to another relation file',
        );
      case 'comfirmUnnumberInvoiceMessageTwikey':
        return $translate.instant(
          'Are you sure want to unnumber this invoice? If the customer has a direct debit contract and the amount was already sent to the bank via Twikey, it is possible the customer will be invoiced even when you unnumber this invoice.',
        );
      case 'msgSomeTaskSchedulesCouldNotBePlanned':
        return $translate.instant(
          'The task schedules were created, but there were some that could not plan the first task:',
        );
      case 'msgMandateCreatedInMollie':
        return $translate.instant('The mandate was created in Mollie');
      case 'msgFirstPaymentMollieCreated':
        return $translate.instant(
          'A mandate will be created when the customer pays their next invoice.',
        );
      case 'comfirmUnnumberInvoiceMessagePaymentProvider':
        return $translate.instant(
          'Are you sure want to unnumber this invoice? If the customer has a direct debit mandate and the amount was already debited via your payment provider, you might have to manually refund this customer.',
        );
      case 'msgConfirmCleanupMonthsTitle':
        return $translate.instant('Are you sure you want to set the cleanup to {{value}}?', params);
      case 'msgConfirmCleanupMonths':
        return $translate.instant(
          'Because if you set it to {{value}}, {{count}} tasks will be removed by tomorrow.',
          params,
        );
      case 'msgConfirmCleanupMonthsAtLeast1000':
        return $translate.instant(
          'Because if you set it to {{value}}, at least 1000 tasks will be removed by tomorrow.',
          params,
        );
      case 'msgValueCopiedToClipboard':
        return $translate.instant('ValueCopiedToClipboard');

      case 'EditTaskTemplateRequiredDocumentTypes':
        return $translate.instant('Add or remove required document types');
      case 'registrationFormContainsErrors':
        return $translate.instant('The registration form contains errors');
      case 'msgConfirmDeleteTodo':
        return $translate.instant('Are you sure you want to delete this todo?');
      case 'msgConfirmTurnOffAbsenceCounter':
        return $translate.instant(
          'Are you sure you want to turn off the counter for this absence?',
        );
      case 'msgSomeLanguagesContainValidationErrors':
        return $translate.instant('Some languages contain validation errors');

      case 'msgCreateRelationGroup':
        return $translate.instant('Do you want to create the relation group {{value}}?', params);
      case 'msgCheckinWarning':
        return $translate.instant(
          'Something went wrong checking in the document, this could be caused by the document having been deleted in OneDrive. The checkout has been discarded instead.',
        );
      case 'msgCheckinSuccesfull':
        return $translate.instant('Successfully checked in file.');
      case 'msgConfirmDeleteRequiredAuthorization': {
        return $translate.instant('Are you sure you want to delete this authorization?');
      }
      case 'msgCheckedOutBy':
        return $translate.instant('Document is checked out by {{name}}', params);
      case 'confirmFinalizeNegativeInvoice':
        return $translate.instant(
          'Are you sure you want to finalize this negative invoice? If this is a creditnote, please use the button to convert it to a creditnote.',
        );
      case 'confirmFinalizePositiveCreditNote':
        return $translate.instant(
          'Are you sure you want to finalize this positive creditnote? If this is an invoice, please use the button to convert it to an invoice.',
        );
      case 'msgDraftInvoicesUnlocked':
        return $translate.instant('The selected draft invoices have been unlocked.');
      case 'msgDraftInvoicesLocked':
        return $translate.instant('The selected draft invoices have been locked.');
      case 'msgConfirmDeleteHoliday':
        return $translate.instant('Are you sure you want to delete bank holiday {{date}}?', params);
      case 'msgRegistrationsWillBeModifiedInTheBackground':
        return $translate.instant('The registrations will be modified in the background.', params);
      case 'msgConfirmCreateRelationInVisionPlanner':
        return $translate.instant(
          'Relation will be created in VisionPlanner, are you sure?',
          params,
        );

      default:
        //Fallback try to translate
        return $translate.instant(msgString, params);
    }
  };
}
